import { apiJson } from '../../shared/api/http';

export type NotificationTabKey = 'all' | 'unread' | 'needs_you';

export interface NotificationAction {
  key: string;
  label: string;
  kind: 'execute' | 'link';
  url?: string;
  primary: boolean;
}

export interface NotificationItem {
  id: string;
  type: string;
  title: string;
  message?: string | null;
  related_id?: string | null;
  action_url?: string | null;
  is_read: number;
  created_at: string | null;
  action_state?: string | null;
  actions: NotificationAction[];
  needs_you: boolean;
  available: boolean;
}

export interface NotificationPage {
  items: NotificationItem[];
  next: string | null;
  unread: number;
  needs_you: number;
}

export function fetchNotificationPage(tab: NotificationTabKey, before?: string | null, limit = 20): Promise<NotificationPage> {
  const params = new URLSearchParams({ tab, limit: String(limit) });
  if (before) params.set('before', before);
  return apiJson(`/api/notifications?${params.toString()}`, { auth: true });
}

export function fetchNotificationCounts(): Promise<{ unread: number; needs_you: number }> {
  return apiJson('/api/notifications/unread-count', { auth: true });
}

export function markNotificationRead(id: string) {
  return apiJson(`/api/notifications/${id}/read`, { method: 'POST', auth: true });
}

export function markAllNotificationsRead() {
  return apiJson('/api/notifications/read-all', { method: 'POST', auth: true });
}

export function dismissNotification(id: string) {
  return apiJson(`/api/notifications/${id}`, { method: 'DELETE', auth: true });
}

export function dismissReadNotifications(): Promise<{ ids: string[] }> {
  return apiJson('/api/notifications/dismissed', { method: 'DELETE', auth: true });
}

export function restoreNotifications(ids: string[]) {
  return apiJson('/api/notifications/restore', { method: 'POST', auth: true, body: { ids } });
}

export function runNotificationAction(id: string, action: string): Promise<NotificationItem> {
  return apiJson(`/api/notifications/${id}/actions/${action}`, { method: 'POST', auth: true });
}
